import React from 'react';
export function Footer() {
  return <footer className="bg-primary-dark text-white pt-16 pb-8" data-id="element-101">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-102">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-103">
          <div data-id="element-104">
            <h3 className="font-heading text-3xl font-bold mb-4 text-accent mt-[-10px]" data-id="element-105">
              Dům u Sv. Václava
            </h3>
            <p className="max-w-xs text-[#8C8B7C]" data-id="element-106">
              Nejmodernější ekologický bytový dům v ČR. 52 bytových jednotek,
              energetická soběstačnost, supermarket 24/7/365 a kavárna na střeše
              v obci Dolní Jirčany/Psáry.
            </p>
          </div>

          <div data-id="element-107">
            <h4 className="font-bold mb-4 text-accent uppercase tracking-wider text-sm" data-id="element-108">
              Rychlé odkazy
            </h4>
            <ul className="space-y-2 text-white/70" data-id="element-109">
              <li data-id="element-110">
                <a href="#o-projektu" className="hover:text-white transition-colors" data-id="element-111">
                  O projektu
                </a>
              </li>
              <li data-id="element-112">
                <a href="#galerie" className="hover:text-white transition-colors" data-id="element-113">
                  Galerie
                </a>
              </li>
              <li data-id="element-114">
                <a href="#vyhody" className="hover:text-white transition-colors" data-id="element-115">
                  Výhody
                </a>
              </li>
              <li data-id="element-116">
                <a href="#lokalita" className="hover:text-white transition-colors" data-id="element-117">
                  Lokalita
                </a>
              </li>
              <li data-id="element-118">
                <a href="#byty" className="hover:text-white transition-colors" data-id="element-119">
                  Nabídka bytů
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-120">
            <h4 className="font-bold mb-4 text-accent uppercase tracking-wider text-sm" data-id="element-121">
              Kontakt
            </h4>
            <ul className="space-y-2 text-white/70" data-id="element-122">
              <li data-id="element-123">Projekt společnosti BRAMAL PROJECT s.r.o.</li>
              <li data-id="element-124">info@svatyvaclav.living</li>
              <li data-id="element-125">+420 602 304 915</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-white/50" data-id="element-126">
          <p data-id="element-127">© 2026 BRAMAL PROJECT s.r.o. Všechna práva vyhrazena.</p>
          <p className="mt-2 md:mt-0" data-id="element-128">Design pro Dům u Sv. Václava</p>
        </div>
      </div>
    </footer>;
}